module.exports = __webpack_public_path__ + "img/prize-content.bcbb07fb.png";